import { pushVideoEvent, VIDEO } from "../../video/events";

// Youtube
export function embedYtScript(ytVideo, config) {
    let ytIframeAPI = "https://www.youtube.com/iframe_api";
    if (typeof window.YT == "undefined" || typeof window.YT.Player == "undefined") {
        let tag = document.createElement("script");
        tag.src = ytIframeAPI;
        let firstScriptTag = document.querySelector("script");
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        if (Array.isArray(window.ytIframes)) {
            window.ytIframes.push({ ytVideo, config });
        } else {
            window.ytIframes = [{ ytVideo, config }];
        }

        window.onYouTubePlayerAPIReady = function () {
            window.ytIframes.forEach(ytIframe => onYouTubeReady(ytIframe.ytVideo, ytIframe.config));
        };
    } else {
        onYouTubeReady(ytVideo, config);
    }
}

export function onYouTubeReady(ytVideo, config) {
    let id = ytVideo.getAttribute("id");
    let videoId = ytVideo.dataset.videoid;
    let title = ytVideo.dataset.title;
    let carousel = ytVideo.closest(".carousel__wrap");
    let eventsPushed = {};
    let VIDEO_DURATION = null;
    let timer = null;
    
    const onApiChange = () => {
        if (typeof player.setOption === 'function' && config.cc_load_policy === "1") {
            player.setOption('captions', 'track', { languageCode: config.cc_lang_pref })
        }  
    }

    const convertTime = time => {
        const splitTime = time.split(":");
        const arrLen = splitTime.length;
        let hh = 0;
        let mm = 0;
        let ss = 0;

        if (arrLen === 3) {
            hh = Number(splitTime[0]) * 3600;
            mm = Number(splitTime[1]) * 60;
            ss = Number( splitTime[2]);
        } else if (arrLen === 2) {
            mm = Number(splitTime[0]) * 60;
            ss = Number(splitTime[1]);
        } else {
            ss = Number(splitTime[0]);
        }

        return hh + mm + ss;
    }
    
    if (config.start) config.start = convertTime(config?.start);
    if (config.end) config.end = convertTime(config?.end);

    const [ videoIdNoParam ] = videoId.split("?");

    if (config.playlist) config.playlist = videoIdNoParam;

    let player = new window.YT.Player(id, {
        videoId: videoIdNoParam,
        title: title,
        host: 'https://www.youtube-nocookie.com',
        playerVars: {
            playsinline: 1,
            ...config
        },
        events: {
            onStateChange: onPlayerStateChange,
            onError: onPlayerError,
            onApiChange,
        },
    });

    player.addEventListener("onReady", (e) => {
        if (e.target.playerInfo.duration === 0) {
            pushVideoEvent({
                event: VIDEO.error,
                event_type: "error",
                video_duration: e.target.playerInfo.videoData.duration,
                video_provider: "Youtube",
                video_percent: "0%"
            });
            eventsPushed[VIDEO.error] = true;
        } else {
            if (ytVideo.closest(".tns-slide-cloned")) {  // to avoid duplicate "view" push, due to carousel cloning of slides
                eventsPushed[VIDEO.loaded] = true;
            } else {
                if (!eventsPushed[VIDEO.loaded]) {
           
                    pushVideoEvent({
                        event: VIDEO.loaded,
                        event_type: "load",
                        video_duration: e.target.playerInfo.duration,
                        video_provider: "Youtube",
                        video_percent: "0%"
                    });
 
                    eventsPushed[VIDEO.loaded] = true;
                }
            }
        }
    });

    function handlePercentWatched() {
        if (player && player.getCurrentTime) {
            let videoTime = player.getCurrentTime();
            // let videoTitle = event.target.playerInfo?.videoData?.title == "" ? title : event.target.playerInfo.videoData.title;

            //video duration changes on replay for some videos and never allows video_progress_100%
            //capturing the initial player duration remedies this
            if (!VIDEO_DURATION) {
                VIDEO_DURATION = player.getDuration();
            }

            let pct = (videoTime / VIDEO_DURATION) * 100;
            let pctCeil = Math.ceil(pct);
            if (pctCeil >= 10 && pctCeil % 10 === 0) {
                if (!eventsPushed[pctCeil]) {
                    eventsPushed[pctCeil] = true;
                    pushVideoEvent({
                        event: VIDEO.progress(pctCeil),
                        event_type: "progress",
                        video_duration: VIDEO_DURATION,
                        video_percent: `${pctCeil}%`,
                        video_provider: "Youtube"
                    });
                }
            }
        }
    }

    function onPlayerStateChange(event) {
        /*
         event.target.playerInfo.playerState
         0 = ended
         1 = playing
       */

        const duration = event.target.playerInfo.duration;
        const state = event.data; // reliable source per YT Iframe API

        if (state === window.YT.PlayerState.PLAYING) {
            if (!eventsPushed[VIDEO.start]) {

                pushVideoEvent({
                    event: VIDEO.start,
                    event_type: "start",
                    video_duration: duration,
                    video_provider: "Youtube",
                    video_percent: "0%"
                });

                eventsPushed[VIDEO.start] = true;
            }

            if (timer) {
                clearInterval(timer);
            }

            timer = setInterval(handlePercentWatched, 100, event);
            if (carousel) {
                const carouselId = carousel.dataset.uuid;
                const tnsCarousel = window.tnsCarousels.find((x) => x.uuid == carouselId);
                if (tnsCarousel) {
                    tnsCarousel.carousel.pause();
                }
            }
        } else if (state === window.YT.PlayerState.ENDED) {
            //clear evnets pushed in case user wants to replay
            eventsPushed = {};
            pushVideoEvent({
                event: VIDEO.complete,
                event_type: "complete",
                video_duration: duration,
                video_provider: "Youtube",
                video_percent: "100%"
            });

            clearInterval(timer);
        } else if (event.target.playerInfo.playerState === window.YT.PlayerState.PAUSED) {
            clearInterval(timer);
        }
    }

    function onPlayerError(event) {
        if (timer) {
            clearInterval(timer);
        }

        if (!eventsPushed[VIDEO.error]) {
            pushVideoEvent({
                event: VIDEO.error,
                event_type: "error",
                video_duration: event.target.playerInfo.duration,
                video_provider: "Youtube",
                video_percent: "0%"
            });

            eventsPushed[VIDEO.error] = true;
        }
    }
}
